import {useCallback} from "react";
import {useAppToast} from "@ui-seeker/app";

import {repricingAlertsClicked, repricingIsLoadingNotifications} from "../../@signals";


export default function useRepricingFilters(ruleID) {
	const { showToast } = useAppToast()

	const handleClicked = useCallback(() => {
		if (repricingIsLoadingNotifications.value) {
			showToast.warning('Please wait for notifications to load before filtering. Thank you.')
		} else {
			if (repricingAlertsClicked.value.includes(ruleID)) {
				repricingAlertsClicked.value = [...repricingAlertsClicked.value.filter(id => id !== ruleID)]
			} else {
				repricingAlertsClicked.value = [...repricingAlertsClicked.value, ruleID]
			}
		}
	}, [ruleID])

	return {
		repricingAlertsClicked: repricingAlertsClicked.value,
		isFiltered: repricingAlertsClicked.value.includes(ruleID),
		handleClicked
	}
} 